// extracted by mini-css-extract-plugin
export default {"mCard":"vz-z","image":"wz-z","imageNoBackground":"xz-z","imageHasCategory":"yz-z","fullWidth":"zz-z"};